import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AppType } from '../model/app-type.model';
import { Delegation } from '../model/delegation.model';
import { createRequestOption, SearchWithPagination } from '../utils/request-util';
import { ApplicationConfigService } from '../../core/config/application-config.service';

@Injectable({ providedIn: 'root' })
export class DelegationService {
    private resourceUrl = "api/delegation";
    private resourceAdminUrl = "api/admin/delegation";

    constructor(
        private http: HttpClient,
        private applicationConfigService: ApplicationConfigService
    ){}


    query(req?: SearchWithPagination): Observable<HttpResponse<Delegation[]>> {
        const options = createRequestOption(req);
        return this.http.get<Delegation[]>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}`,{params: options, observe: 'response'});
    }

    get(id: number): Observable<Delegation> {
        return this.http.get<Delegation>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/${id}`);
    }

    update(referentToUpdate: AppType): Observable<Delegation> {
        return this.http.put<Delegation>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/${referentToUpdate.id!}`, referentToUpdate);
    }

    save(referentToCreate: Delegation): Observable<Delegation> {
        return this.http.post<Delegation>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}`, referentToCreate);
    }
    
    delete(id: number): Observable<HttpResponse<void>> {
        return this.http.delete<void>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/${id}`, {observe: 'response'});
    }

    getReferentEmail() : Observable<Delegation> {
        return this.http.get<Delegation>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/email`);
    }

    isDelegatedUser() : Observable<boolean> {
        return this.http.get<boolean>(`${this.applicationConfigService.getEndpointFor(this.resourceUrl)}/delegated`);
    }


}